/*
 * @Author: liujinlei liujinlei@zhihuiliu.com
 * @Date: 2023-12-20 11:59:18
 * @LastEditors: liujinlei liujinlei@zhihuiliu.com
 * @LastEditTime: 2023-12-20 14:07:17
 * @FilePath: \zjEngnlish\src\assets\js\ali-sdk.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import { Toast } from 'vant'
import Recorder from 'js-audio-recorder'
import axios from 'axios'
import {
  getArgs,
  getCookie,
  zhlType
} from '@/assets/js/common'
const Log = console.log.bind(document)
class ALIRecorder {
  constructor(opthion) {
    // Log('ali初始化')
    this.zhlRecorder = new Recorder({
      sampleBits: 16,
      sampleRate: 8000,
      numChannels: 1
    })
  }

  //开始录音
  startRecord() {
    // Log('ali开始录音')
    this.zhlRecorder.start().then(
      () => {
        this.recordStartTime = parseInt(new Date().getTime() / 1000)
        this.recording = true
        // Log('ali录音中...')
      },
      (err) => {
        Log('ali录音失败', err)
      }
    )
  }

  //停止录音
  stopRecord() {
    if (this.recording) {
      this.recording = false
      // Log('ali录音完成,提交录音')
      this.zhlRecorder.stop()
      this.duration = parseInt(new Date().getTime() / 1000) - this.recordStartTime
      if (this.duration < 1) {
        this.duration = 1
      }
      const fileBlob = this.zhlRecorder.getWAVBlob()
      // 请求识别结果
      getRecordText(fileBlob).then(result => {
        // Log('ali录音结果', result)
        // 获取调用结果
        const info = {
          resultStr: result.data.data.content,
          audioUrl: URL.createObjectURL(fileBlob),
          duration: this.duration,
        }
        this.recorderOnResult(JSON.stringify(info))
      })
    }
  }

  //录音结果
  recorderOnResult(result) {
    Log('YZSRecorder 处理后的结果', result)
  }
}


// 调用阿里语音识别api
function getRecordText(blob) {
  const fileName = 'WAV' + new Date().getTime() + '.wav'
  const file = new File([blob], fileName, { type: blob.type })
  const scope = zhlType.getScope()
  const token = getCookie('token') || getArgs().token
  let UPLOAD_URL = ''
  if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_build_type === 'test') {
    UPLOAD_URL = 'https://zhl-test.xxfz.com.cn/113-service/debug-8055/zhl-file/nls/recog/submit'
  } else {
    UPLOAD_URL = 'https://file-manage.xxfz.com.cn/nls/recog/submit'
  }
  const param = new FormData()
  param.append('file', file)
  param.append('compress_type', '0')
  param.append('file_type', 'wav')
  param.append('token', token)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: token,
      Scope: scope
    }
  }
  return axios.post(UPLOAD_URL, param, config)
}

export default ALIRecorder
